import React from "react";
import { TableColumn } from "react-data-table-component";
import { Badges } from "../../AbstractElements";
import { useTranslation } from "react-i18next";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { MoreVertical } from "react-feather";
 import { showWarningAlert } from "../../utils/showWarningAlert";

const StatusBadge = ({ status }: { status: string }) => (
    <Badges
      color="transparent"
      className={`badge-light-${
        status === "Active" ? "success" : 
        status === "Blocked" ? "danger" : 
        "warning"
      }`}
    >
      {status}
    </Badges>
  );
  export const IPManagementAction: React.FC<{ row: any; tabType: string }> = ({ row, tabType }) => {
    const { t } = useTranslation();
    const handleWhiteList = () => {
        showWarningAlert({
          title: t("Are you sure?"),
          text: `Do you want to Whitelist ${row.ipAddress}?`,
          confirmButtonText: t("Okay"),
          onConfirm: () => {
            // Block logic here
          },
        });
      };
  
      const handleBlackList = () => {
        showWarningAlert({
          title: t("Are you sure?"),
          text: `Do you want to BlackList ${row.ipAddress}?`,
          confirmButtonText: t("Confirm"),
          onConfirm: () => {
            // Unblock logic here
          },
        });
      };
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className="cursor-pointer">
          <MoreVertical size={18} />
        </DropdownToggle>
        <DropdownMenu>
          {tabType === "1" && (
            <DropdownItem onClick={handleBlackList}>{t("Blacklist")}</DropdownItem>
          )}
          {tabType === "2" && (
            <DropdownItem onClick={handleWhiteList}>{t("Whitelist")}</DropdownItem>
          )}
          {tabType === "3" && (
            <>
              <DropdownItem onClick={handleWhiteList}>{t("Whitelist")}</DropdownItem>
              <DropdownItem onClick={handleBlackList}>{t("Blacklist")}</DropdownItem>
            </>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };
  
  
  // IP Table Columns
  export const getIPColumns = (t: any, tabType: string): TableColumn<any>[] => [
    {
      name: t("Sl.No") || "Sl.No",
      selector: (row) => row.id,
      width: "80px",
      center: true,
    },
    {
      name: t("IPAddress") || "IP Address",
      selector: (row) => row.ipAddress,
      sortable: true,
      grow: 2,
    },
    {
      name: t("LastActivity") || "Last Activity",
      selector: (row) => row.lastActivity,
      sortable: true,
      grow: 2,
    },
    {
      name: t("DateTime") || "Date & Time",
      selector: (row) => row.dateTime,
      sortable: true,
      grow: 2,
    },
    {
      name: t("Location") || "Location",
      selector: (row) => row.location,
      sortable: true,
      grow: 2,
    },
    {
      name: t("Hits") || "Hits",
      selector: (row) => row.hits,
      sortable: true,
      grow: 2,
    },
    // {
    //     name: t("Status") || "Status",
    //     cell: (row) => <StatusBadge status={row.status} />,
    //     sortable: true,
    //   },
      {
        name: t("Actions") || "Actions",
        cell: (row) => <IPManagementAction row={row} tabType={tabType} />,
        center: true,
        width: "120px",
      },
  ];
  